import type { Mascotte } from '../types/database';

export const mascottesData: Mascotte[] = [
  {
    id: 'mark-z',
    nom: 'Mark Z.',
    avatar: '/img/mascottes/visuel.png',
    image: '/img/mascottes/mark-z-full.png'
  },
  {
    id: 'sandrine-m',
    nom: 'Sandrine M.',
    avatar: '/img/mascottes/visuel.png',
    image: '/img/mascottes/mark-z-full.png'
  },
  {
    id: 'claude-m',
    nom: 'Claude M.',
    avatar: '/img/mascottes/visuel.png',
    image: '/img/mascottes/mark-z-full.png'
  },
  {
    id: 'orlando-b-cognitifs',
    nom: 'Orlando B.',
    avatar: '/img/mascottes/cognitifs.png',
    image: '/img/mascottes/mark-z-full.png'
  },
  {
    id: 'ozzy-o-moteurs',
    nom: 'Ozzy O.',
    avatar: '/img/mascottes/moteurs.png',
    image: '/img/mascottes/mark-z-full.png'
  },
  {
    id: 'channing-t',
    nom: 'Channing T.',
    avatar: '/img/mascottes/cognitifs.png',
    image: '/img/mascottes/mark-z-full.png'
  },
  
];